export const config = {
  dataset: String(process.env.NEXT_PUBLIC_SANITY_DATASET) || "production",
  projectId: String(process.env.NEXT_PUBLIC_SANITY_PROJECT_ID),
  apiVersion: "2021-10-21",
  useCdn: process.env.NODE_ENV === "production",
};
